import qs from 'qs';
import { HttpService } from '../../http';
import { IWindowResources } from '../window-resources.interface';
import { SubscriptionConfiguration } from './subscription.configuration';
import { SubscriptionEntity } from './subscription.entity';

export class SubscriptionResource {

    public readonly configuration: SubscriptionConfiguration;

    private static instance: SubscriptionResource;

    private readonly http: HttpService;

    constructor(configuration: SubscriptionConfiguration) {
        this.configuration = configuration;
        this.http = HttpService.getInstance(configuration);
    }

    public static getInstance(configuration: SubscriptionConfiguration): SubscriptionResource {
        const windowInstance = this.getDOMInstance();
        if (windowInstance && windowInstance.configuration.clientId === configuration.clientId) {
            return windowInstance;
        }

        if (!this.instance) {
            const win = window as IWindowResources & typeof globalThis;
            this.instance = new SubscriptionResource(configuration);

            win.DWSResources = {
                ...win.DWSResources,
                Subscription: this.instance,
            };
        }

        return this.instance;
    }

    private static getDOMInstance(): SubscriptionResource | undefined {
        const win: IWindowResources = window as IWindowResources & typeof globalThis;
        return win && win.DWSResources !== undefined ? win.DWSResources.Subscription : undefined;
    }

    public async createSubscriptionWith(data: SubscriptionEntity): Promise<any> {
        try {
            const requestPromise = await this.http.post<SubscriptionEntity>(this.configuration.endpoint, qs.stringify(data));
            return Promise.resolve(requestPromise.data);
        } catch (e) {
            return Promise.reject(e);
        }
    }

}
